module.exports = require("npm:stream-http@2.3.0/index.js");